module.exports = __webpack_public_path__ + "static/icon-program-ffd69fd4c0872ee5b7b429743ca2343f.png";